module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sunday")])])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("MARKETS")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "box_chapter"
  }, [_c('p', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('em', [_vm._v("Best")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01_sec2"
    }
  }, [_vm._v("Coustellet "), _c('em', [_vm._v("(farmers’ market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01_sec4"
    }
  }, [_vm._v("L’Isle-sur-la-Sorgue "), _c('em', [_vm._v("(flea/antiques & traditional Provençal market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saint-Martin-de-la-Brasque "), _c('em', [_vm._v("(farmers’ market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c05_sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avignon "), _c('em', [_vm._v("(covered market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_c('em', [_vm._v("Others")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aix-en-Provence "), _c('em', [_vm._v("(monthly book market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ansouis "), _c('em', [_vm._v("(traditional Provençal market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carpentras "), _c('em', [_vm._v("(flea/antiques market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Châteaurenard "), _c('em', [_vm._v("(traditional Provençal market)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c06_sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nîmes "), _c('em', [_vm._v("(covered market)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430ff4de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 87
// module chunks = 0